export default __webpack_public_path__ + "static/media/fsk-17-a.d39734a5.jpg";